import React from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import '../styles/Perks.css'
import pic from '../assets/reward1.png'
export default function Perks() {
    return (
        <div className='perks_container'id="perks_container">
            <Splide options={{
                rewind: true,
                width: "100%",
                gap: '1rem',
                arrows: false
            }}>
                <SplideSlide>
                    <div id="slide1" className='in_slides'>
                        <h1>Perks On milestones</h1>
                        <img src={pic} />
                        <p>
                            At every milestone perks will be distributed among our customers , without any partiality .
                            <artilce>
                                For more details please swipe left.
                            </artilce>
                        </p>
                    </div>
                </SplideSlide>
                <SplideSlide>
                    <div id="slide2" className='in_slides'>
                        <ul>
                            <h1>List of perks...</h1>
                            <li>100 NFT SOLD- A Lucky person will be picked out of first 100 NFT holder which will get 1 NFT for free.</li>
                            <li>500 NFT SOLD-  3 Lucky customers will get 100$ each.</li>
                            <li>1000 NFT SOLD-  1 Lucky customer’s gets a one time chance to order a customised NFT and sneak peak into our upcoming NFTs.</li>
                            <li>2000 NFT SOLD - A lucky customer gets a free latest Apple AirPods</li>
                            <li>3000 NFT SOLD - A lucky  customer gets a free beats head phone</li>
                            <li>4000 NFT SOLD - A lucky customer gets a ps 5 with 5 games .</li>
                            <li>5000 NFT SOLD - A lucky customer gets a </li>
                            <li>6000 NFT SOLD - A lucky customer gets a occulus VR headset.</li>
                            <li>7000 NFT SOLD - A lucky customer gets a latest ipad air (256Gb version).</li>
                            <li>8000 NFT SOLD - A lucky customer gets a drone.</li>
                            <li>9000 NFT SOLD - A lucky customer gets a latest iphone.</li>
                            <li>1000 NFT SOLD - A lucky customer gets to win 3 ETH (Yup , you read it right).</li>
                            <li><h2>Atlast The Book will be unlocked</h2></li>
                        </ul>
                    </div>
                </SplideSlide>
                <SplideSlide>
                    <div id="slide3">
                        <h1>Terms and conditions regarding the perks</h1>
                        <ol>
                        <li>Giveaways will be always announced on our website & lucky customer will be contacted from our official social handles only.</li>
                        <li>Lucky customer wouldn't be asked for any delivery charges or any other miscellaneous charges.</li>
                        <li>Any request for changing the giveaway item would be decided by founders & their judgment will be final.</li>
                        <li>We target whole globe and any problems related delivery shall be listened carefully.</li>
                        <li>Lucy draw decided will be from last perk to the new perk achieved. ( for ex. Giveaway of perk On completing 1000 NFT will be decided from customers who purchased from NFT number 501-1000. Similarly giveaway of completing 2000 NFT will be decided from customers who purchased from NFT number 1001-2000).</li>
                        <li>Giveaways will be made public for full transparency.</li>
                
                        </ol>
                    </div>
                </SplideSlide>
            </Splide>
        </div>
    )
}
